import { OnSubmitValues } from '@common/components/Job/EnhanceJob/EnhanceJobWithCoins';

type Params = OnSubmitValues;

export const toJob = (jobId: string, job: Params) => ({
  id: jobId,
  rightToWork: job.rightToWork,
  immediateStart: job.immediateStart,
  videoQuestions: [
    {
      code: job.videoScreeningQuestion,
      customQuestion: job.customVideoQuestion
    }
  ]
});
